import { createFileRoute } from "@tanstack/react-router";
import CityPageV2 from "@/pages/CityPageV2";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/cities/$city/")({
  head: ({ params }) => routeHead("/de/cities/$city/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CityPageV2 />
  );
}
